import collectionReducer from '../collectionReducer';

export default collectionReducer({
    apiCollectionName: 'mailroomEvents',
    collectionActionName: 'MAILROOM_EVENTS',
    itemActionName: 'MAILROOM_EVENT',
});
